export default [
  {
    path: '/:locale([en]*)?/information-center',
    name: 'InformationCenter',
    component: () => import('@/views/information/Index'),
    redirect: { name: 'CustomerServiceCenter' },
    meta: {
      sitemap: {
        loc: '/information-center'
      }
    },
    children: [
      {
        path: 'customerServiceCenter',
        name: 'CustomerServiceCenter',
        component: () => import('@/views/information/CustomerServiceCenter'),
        meta: {
          // language: false,
          parent: 'Consult'
        }
      },
      {
        path: 'consult',
        name: 'InformationCenterConsult',
        component: () => import('@/views/information/Consult'),
        meta: {
          // language: false,
          parent: 'Consult'
        }
      },
      {
        path: 'report',
        name: 'InformationCenterReport',
        component: () => import('@/views/information/Report'),
        meta: {
          // language: false,
          parent: 'Consult'
        }
      }
    ]
  }
]
